import React from 'react';
import { Box, Stepper, Step, StepLabel } from '@mui/material';
import { HelpOutline, ImageSearch, CheckCircle } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../design-system/tokens/colors';

interface BiometricStepsHeaderProps {
  active: number; // 0: Decisão, 1: Recorte/Envio ou Resultado
}

const steps = [
  { icon: <HelpOutline /> },
  { icon: <ImageSearch /> },
];

const BiometricStepsHeader: React.FC<BiometricStepsHeaderProps> = ({ active }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Stepper activeStep={active} sx={{ mt: 0 }}>
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel icon={step.icon} />
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default BiometricStepsHeader;